// Bowlscout version of table container component

import { TableContainer } from '@mui/material';

const BSTableContainer = ({ children, sx }) => {
  return (
    <TableContainer
      sx={{
        width: '100%',
        boxShadow: 2,
        borderRadius: 2,
        backgroundColor: (theme) => theme.palette.background.paper
      }}>
      {children}
    </TableContainer>
  );
};

export default BSTableContainer;
